import { put, select, takeLatest } from 'redux-saga/effects'
import {
  HANDLE_WS_SLIDE_MESSAGE,
  SET_CURSOR_POSITION,
  SET_DRAW_LINES,
  SET_SLIDE,
  ADD_LINE_COORDINATES,
  ADD_LINE,
  UNDO_LINE,
  CLEAR_LINES
} from '../redux/slidesReducer'
import { RootReducer } from '../redux/rootReducer'

function* HandleSlidesWsMessageFlow({ payload }: any): Generator<any, void, any> {
  if (Object.keys(payload)[0] === 'slide') {
    yield put(SET_SLIDE(payload.slide))
  }
  if (Object.keys(payload)[0] === 'cursor_position') {
    const user = yield select((state: RootReducer) => state.slidesReducer.user)
    if (user === payload.cursor_position.to) {
      yield put(SET_CURSOR_POSITION(payload.cursor_position))
    }
    const drawLines = yield select((state: RootReducer) => state.slidesReducer.drawLines)
    if (drawLines) {
      yield put(ADD_LINE_COORDINATES(payload.cursor_position))
    }
  }
  if (Object.keys(payload)[0] === 'cursor_up') {
    yield put(SET_DRAW_LINES({ drawLines: false }))
  }
  if (Object.keys(payload)[0] === 'cursor_down') {
    yield put(ADD_LINE())
    yield put(SET_DRAW_LINES({ drawLines: true }))
  }
  if (Object.keys(payload)[0] === 'undo_line') {
    yield put(UNDO_LINE())
  }
  if (Object.keys(payload)[0] === 'clear_lines') {
    yield put(CLEAR_LINES())
  }
}

export default function* HandleSlidesWsMessageSaga(): Generator<any, void, any> {
  yield takeLatest([HANDLE_WS_SLIDE_MESSAGE], HandleSlidesWsMessageFlow)
}
